const getTeamStatsType = (data: TeamsStatsBlockMatch): TeamsStatsType | null => {
  switch (data.videogame_slug) {
    case 'cs-go':
      return 'maps_winrate';
    case 'dota-2':
    case 'league-of-legends':
      return 'team';
    default:
      return null;
  }
};

const hasTeamData = (data: TeamsStatsBlockMatch, dataType: TeamsStatsType | null): boolean => {
  switch (dataType) {
    case 'maps_winrate':
      return Boolean(data.maps_winrate?.length);
    case 'team':
      return data.opponents.some(opponent => opponent.stats);
    default:
      return false;
  }
};

export { getTeamStatsType, hasTeamData };
